export const defaultAddress = { 
  number: '', 
  street: '', 
  city: '', 
  state: '', 
  country: '' 
}

export default defaultAddress